export const toggleLoading = () => ({
  type: 'TOGGLE_LOADING'
});

export const setError = (opt = true) => ({
  type: 'SET_ERROR',
  opt
});

export const toggleIsDesktop = isDesktop => {
  return {
    type: 'TOGGLE_IS_DESKTOP',
    isDesktop
  };
};
